// Mirrors src/Domain/Constants/Roles.cs — values must match the backend exactly.
export const ROLES = Object.freeze({
  ADMINISTRATOR: 'Administrator',
  MEMBER: 'Member',
  REVIEWER: 'Reviewer',
  VIEWER: 'Viewer',
});

export const ROLE_LIST = [ROLES.ADMINISTRATOR, ROLES.MEMBER, ROLES.REVIEWER, ROLES.VIEWER];

export const ROLE_COLORS = Object.freeze({
  [ROLES.ADMINISTRATOR]: 'error',
  [ROLES.MEMBER]: 'primary',
  [ROLES.REVIEWER]: 'info',
  [ROLES.VIEWER]: 'default',
});

// Fallback chip color for org-defined custom roles.
export const DEFAULT_ROLE_COLOR = 'secondary';
